import { Injectable } from '@angular/core';
import { CanLoad, CanActivate, Router} from '@angular/router';
import { AuthService } from './auth.service';
import { AppConstants } from './config.service';

@Injectable()
export class canManageCustomersAuthGuard implements CanActivate {
  constructor(private userService: AuthService) { };

  canActivate() {
    return this.userService.checkRoleExist('certificationCanManageCustomers');
  }

}

@Injectable()
export class canViewCreateCompAuthGuard implements CanActivate {
  constructor(private userService: AuthService) { };

  canActivate() {
    return this.userService.checkRoleExist('createComponentSelections');
  }

}

@Injectable()
export class canViewCustomerSelctionsGuard implements CanActivate {
  constructor(private userService: AuthService) { };

  canActivate() {
    return this.userService.checkRoleExist('CustomerSelections');
  }

}

@Injectable()
export class 
canViewSearchSelectionsGuard implements CanActivate {
  constructor(private userService: AuthService) { };

  canActivate() {
    return this.userService.checkRoleExist('SearchSelections');
  }

}

@Injectable()
export class 
canViewSearchComponentsGuard implements CanActivate {
  constructor(private userService: AuthService) { };

  canActivate() {
    return this.userService.checkRoleExist('SearchComponents');
  }

}

@Injectable()
export class 
canViewSearchNotificationsGuard implements CanActivate {
  constructor(private userService: AuthService) { };

  canActivate() {
    return this.userService.checkRoleExist('SearchNotifications');
  }

}

@Injectable()
export class AuthUsersGuard implements CanActivate {
  constructor(private appConstants : AppConstants,private router : Router,private authService : AuthService) { };
  async canActivate() {
    await this.appConstants.getTenantUserId()
    const isTenantUserIdAvailable = this.appConstants.tenantUserId && this.appConstants.tenantUserId.length ? true : false;
    const isRoleAvailable = await this.authService.checkRoleExist('trutesta-ulc');
    let userStatus = !isTenantUserIdAvailable || !isRoleAvailable ? false : true;
    if(!userStatus)
    this.router.navigate(['/authorized'])
    return userStatus
  }
}
